import { activate_listener } from "./activation";
import { push_listener, notification_click } from "./push";

// Registered by the company-router frontend only: the core UI gets its
// notifications over `/ws/notifications/` and never installs this worker.
declare const self: ServiceWorkerGlobalScope;
export {};

self.addEventListener("install", () => {
  void self.skipWaiting();
});

self.addEventListener("activate", activate_listener);
// Company-router webpush support will be wired in a follow-up commit.
// self.addEventListener("push", push_listener);
// self.addEventListener("notificationclick", notification_click);
